import React from 'react'
import { NavLink,useLocation } from 'react-router-dom';
import {MenuList,MenuItem,Divider,} from "@fluentui/react-components";
import { GenerateImageContext } from "../../../context/GenerateImageContext";
import { bundleIcon, LightbulbFilament24Filled, LightbulbFilament24Regular, Image24Filled, Image24Regular,ChatBubblesQuestion24Filled,ChatBubblesQuestion24Regular
 } from "@fluentui/react-icons";


const NavMobile = () => {

  const { resetImageGenerate } = React.useContext(GenerateImageContext);
  const location = useLocation();
  const GalleryIcon = bundleIcon(Image24Filled, Image24Regular);
  const IdeaIcon = bundleIcon(LightbulbFilament24Filled,LightbulbFilament24Regular);
  const HelpIcon = bundleIcon(ChatBubblesQuestion24Filled,ChatBubblesQuestion24Regular);

  return (
    <MenuList>
      <Divider appearance="strong" />
      <NavLink to="/generate" className="NavLinks">
        <MenuItem
          style={
            location.pathname === "/generate"
              ? { backgroundColor: "#4f52b2" }
              : { backgroundColor: "#333" }
          }
          icon={<IdeaIcon />}
          onClick={() => {
            resetImageGenerate();
          }}
        >
          Idear
        </MenuItem>
      </NavLink>

      <Divider appearance="strong" />
      <NavLink to="/gallery" className="NavLinks">
        <MenuItem
          style={
            location.pathname === "/gallery"
              ? { backgroundColor: "#4f52b2" }
              : { backgroundColor: "#333" }
          }
          icon={<GalleryIcon />}
        >
          Galería
        </MenuItem>
      </NavLink>
      <Divider appearance="strong" />
      <NavLink to="/" className="NavLinks">
        <MenuItem
          icon={<HelpIcon />}
        >
          Ayuda
        </MenuItem>
      </NavLink>
      <Divider appearance="strong" />
  </MenuList>
  )
}

export default NavMobile